<template>
    <!-- 저번시간에 만든거 -->
    <div v-if="iStep == 0">
        <Post :PData="PostData[i]" :iIndex="i" v-for="(a, i) in PostData" :key="i" />
    </div>

    <!-- 필터선택페이지 -->
    <div v-if="iStep == 1">
        <!-- <div class="upload-image" :style="{ backgroundImage: `url(${url})` }"></div> -->
        <div :class="filter" class="upload-image" :style="`background-image:url(${url})`"></div>
        <div class="filters">
            <FilterBox :filter="filter" :url="url" v-for="(filter, i) in Filters" :key="i">
                <span>{{ filter }}</span>
                <!-- <template v-slot:a><span>{{ filter }}</span></template> -->
                <!-- <template v-slot:b><span>{{ filter }}</span></template> -->
                <!-- <template v-slot:default="작명"><span>{{ 작명.msg }}</span></template>                 -->
            </FilterBox>
        </div>
    </div>

    <!-- 글작성페이지 -->
    <div v-if="iStep == 2">
        <div :class="filter" class="upload-image" :style="{ backgroundImage: `url(${url})` }"></div>
        <div class="write">
            <textarea @input="$emit('saveContent', $event.target.value)" class="write-box"></textarea>
        </div>
    </div>
</template>

<script>

import AppPost from './AppPost.vue';
import FilterBox from './FilterBox.vue';

export default {
    name: 'AppContainer',

    // 💡 여기에 emits 옵션을 추가합니다.
    emits: ['saveContent'], 

    data() {
        return {
            Filters: ["aden", "_1977", "brannan", "brooklyn", "clarendon", "earlybird", "gingham", "hudson",
                "inkwell", "kelvin", "lark", "lofi", "maven", "mayfair", "moon", "nashville", "perpetua",
                "reyes", "rise", "slumber", "stinson", "toaster", "valencia", "walden", "willow", "xpro2"],
            filter: '',
        }
    },
    mounted() {
        this.emitter.on('filter', (a) => {
            console.log(a);
            this.filter = a;
        })
    },
    components: {
        Post: AppPost,
        FilterBox: FilterBox,
    },
    props: {
        PostData: Array,
        iStep: Number,
        url: String,
    },
}
</script>

<style>
.upload-image {
    width: 100%;
    height: 450px;
    background: cornflowerblue;
    background-size: cover;
}

.filters {
    overflow-x: scroll;
    white-space: nowrap;
}

.filter-1 {
    width: 100px;
    height: 100px;
    background-color: cornflowerblue;
    margin: 10px 10px 10px auto;
    padding: 8px;
    display: inline-block;
    color: white;
    background-size: cover;
}

.filters::-webkit-scrollbar {
    height: 5px;
}

.filters::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.filters::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 5px;
}

.filters::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.write-box {
    border: none;
    width: 90%;
    height: 100px;
    padding: 15px;
    margin: auto;
    display: block;
    outline: none;
}
</style>